import { render } from "./QuantumRoadmapTabs.vue?vue&type=template&id=8b20fe58"
import script from "./QuantumRoadmapTabs.vue?vue&type=script&lang=js"
export * from "./QuantumRoadmapTabs.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__